import React from 'react';
const DataBase = () => {
    return (
        <p>DataBase</p>
    )
}
export default DataBase;